export default __webpack_public_path__ + "static/GilroyRegular-04da23b27b82ddf52504f5ceb80f25b0.woff2";